import TrailerOutlineIcon from "../../../common/icons/TrailerOutlineIcon";

export default {
  icon: TrailerOutlineIcon,
};
